import { ref } from 'vue';

const phoneCountries = ref([
  // European and Asian Countries combined and sorted alphabetically by country name
  { name: 'Afghanistan', code: 'af', prefix: '+93' },
  { name: 'Albania', code: 'al', prefix: '+355' },
  { name: 'Armenia', code: 'am', prefix: '+374' },
  { name: 'Austria', code: 'at', prefix: '+43' },
  { name: 'Azerbaijan', code: 'az', prefix: '+994' },
  { name: 'Bahrain', code: 'bh', prefix: '+973' },
  { name: 'Bangladesh', code: 'bd', prefix: '+880' },
  { name: 'Belarus', code: 'by', prefix: '+375' },
  { name: 'Belgium', code: 'be', prefix: '+32' },
  { name: 'Bosnia and Herzegovina', code: 'ba', prefix: '+387' },
  { name: 'Bulgaria', code: 'bg', prefix: '+359' },
  { name: 'Bhutan', code: 'bt', prefix: '+975' },
  { name: 'Brunei', code: 'bn', prefix: '+673' },
  { name: 'Croatia', code: 'hr', prefix: '+385' },
  { name: 'Cyprus', code: 'cy', prefix: '+357' },
  { name: 'Czech Republic', code: 'cz', prefix: '+420' },
  { name: 'Denmark', code: 'dk', prefix: '+45' },
  { name: 'Estonia', code: 'ee', prefix: '+372' },
  { name: 'Finland', code: 'fi', prefix: '+358' },
  { name: 'France', code: 'fr', prefix: '+33' },
  { name: 'Georgia', code: 'ge', prefix: '+995' },
  { name: 'Germany', code: 'de', prefix: '+49' },
  { name: 'Greece', code: 'gr', prefix: '+30' },
  { name: 'Hungary', code: 'hu', prefix: '+36' },
  { name: 'Iceland', code: 'is', prefix: '+354' },
  { name: 'India', code: 'in', prefix: '+91' },
  { name: 'Indonesia', code: 'id', prefix: '+62' },
  { name: 'Iran', code: 'ir', prefix: '+98' },
  { name: 'Iraq', code: 'iq', prefix: '+964' },
  { name: 'Ireland', code: 'ie', prefix: '+353' },
  { name: 'Israel', code: 'il', prefix: '+972' },
  { name: 'Italy', code: 'it', prefix: '+39' },
  { name: 'Japan', code: 'jp', prefix: '+81' },
  { name: 'Jordan', code: 'jo', prefix: '+962' },
  { name: 'Kazakhstan', code: 'kz', prefix: '+7' },
  { name: 'Kuwait', code: 'kw', prefix: '+965' },
  { name: 'Kyrgyzstan', code: 'kg', prefix: '+996' },
  { name: 'Laos', code: 'la', prefix: '+856' },
  { name: 'Latvia', code: 'lv', prefix: '+371' },
  { name: 'Lebanon', code: 'lb', prefix: '+961' },
  { name: 'Lithuania', code: 'lt', prefix: '+370' },
  { name: 'Luxembourg', code: 'lu', prefix: '+352' },
  { name: 'Macau', code: 'mo', prefix: '+853' },
  { name: 'North Macedonia', code: 'mk', prefix: '+389' },
  { name: 'Malaysia', code: 'my', prefix: '+60' },
  { name: 'Maldives', code: 'mv', prefix: '+960' },
  { name: 'Malta', code: 'mt', prefix: '+356' },
  { name: 'Moldova', code: 'md', prefix: '+373' },
  { name: 'Monaco', code: 'mc', prefix: '+377' },
  { name: 'Mongolia', code: 'mn', prefix: '+976' },
  { name: 'Montenegro', code: 'me', prefix: '+382' },
  { name: 'Myanmar', code: 'mm', prefix: '+95' },
  { name: 'Netherlands', code: 'nl', prefix: '+31' },
  { name: 'Nepal', code: 'np', prefix: '+977' },
  { name: 'New Zealand', code: 'nz', prefix: '+64' },
  { name: 'Norway', code: 'no', prefix: '+47' },
  { name: 'Oman', code: 'om', prefix: '+968' },
  { name: 'Pakistan', code: 'pk', prefix: '+92' },
  { name: 'Palestine', code: 'ps', prefix: '+970' },
  { name: 'Poland', code: 'pl', prefix: '+48' },
  { name: 'Portugal', code: 'pt', prefix: '+351' },
  { name: 'Qatar', code: 'qa', prefix: '+974' },
  { name: 'Romania', code: 'ro', prefix: '+40' },
  { name: 'Russia', code: 'ru', prefix: '+7' },
  { name: 'Saudi Arabia', code: 'sa', prefix: '+966' },
  { name: 'Serbia', code: 'rs', prefix: '+381' },
  { name: 'Singapore', code: 'sg', prefix: '+65' },
  { name: 'Slovakia', code: 'sk', prefix: '+421' },
  { name: 'Slovenia', code: 'si', prefix: '+386' },
  { name: 'South Africa', code: 'za', prefix: '+27' },
  { name: 'South Korea', code: 'kr', prefix: '+82' },
  { name: 'Spain', code: 'es', prefix: '+34' },
  { name: 'Sri Lanka', code: 'lk', prefix: '+94' },
  { name: 'Sweden', code: 'se', prefix: '+46' },
  { name: 'Switzerland', code: 'ch', prefix: '+41' },
  { name: 'Syria', code: 'sy', prefix: '+963' },
  { name: 'Taiwan', code: 'tw', prefix: '+886' },
  { name: 'Tajikistan', code: 'tj', prefix: '+992' },
  { name: 'Thailand', code: 'th', prefix: '+66' },
  { name: 'Turkey', code: 'tr', prefix: '+90' },
  { name: 'Turkmenistan', code: 'tm', prefix: '+993' },
  { name: 'Ukraine', code: 'ua', prefix: '+380' },
  { name: 'United Arab Emirates', code: 'ae', prefix: '+971' },
  { name: 'United Kingdom', code: 'gb', prefix: '+44' },
  { name: 'Uzbekistan', code: 'uz', prefix: '+998' },
  { name: 'Vietnam', code: 'vn', prefix: '+84' },
  { name: 'Yemen', code: 'ye', prefix: '+967' }
]);

export default phoneCountries;
